export default "__VITE_ASSET__ff76ad72__"